/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  customerContainer: {
    flexGrow: 1,
    width: '100%',
    position: "fixed",
    overflow: "hidden",
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
  },
  isIframe: {
    // marginLeft: theme.spacing(.5),
  },
  customerHeader: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
  },
  customerTitle: {
    padding: theme.spacing(2),
    fontWeight: 700,
    fontSize: theme.spacing(2.5),
    color: theme.palette.text.primary,
  },
  customerHeaderTitle: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  customerHeaderTitleWrap: {
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    }
  },
  customerHeaderText: {
    ZIndex: 1,
    fontWeight: 500,
    fontSize: theme.spacing(2),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: theme.spacing(120),
    lineHeight: theme.spacing(3.5),
    color: theme.palette.text.primary,
  },
  customerDetailsWrap: {
    width: "100%",
    borderWidth: 1,
    height: "90vh",
    overflow: "hidden",
    borderStyle: "solid",
    borderRadius: theme.spacing(0.5),
    borderColor: theme.palette.grey[300],
    backgroundColor: theme.palette.background.default
  },
  headerRightWrap: {
    display: "flex",
  },
  threeDotMenu: {
    width: theme.spacing(4),
  },
  menuActionWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  menuItemText: {
    marginLeft: theme.spacing(0.5),
  },
  customerInput: {
    width: theme.spacing(50),
  },
  dropDownListWrap: {
    height: theme.spacing(60),
    width: theme.spacing(50),
    bgcolor: theme.palette.background.default,
  },
}));
